<template>
	<v-sheet elevation="0">
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<ValidationError :errors="errors" />
			<v-form ref="form" v-model="valid">
				<CustomerCompanyForm
					:customer_company_data.sync="customer_company"
					:industries="industries"
					:customer_company_share_info.sync="customer_company_share_info"
					:customer_company_share_infos="customer_company_share_infos"
					:cutoffDates="cutoffDates"
				/>
				<v-row no-gutters class="my-4" justify="center">
					<v-btn color="secondary" @click="submitForm" :disabled="!valid">
						<v-icon class="mr-2">mdi-plus</v-icon>
						登録する
					</v-btn>
				</v-row>
			</v-form>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import _ from "lodash"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import ValidationError from "../shared/ValidationError.vue"
import CustomerCompanyForm from "./components/CustomerCompanyForm.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		ValidationError,
		CustomerCompanyForm,
	},
	data() {
		return {
			mainTitle: "顧客企業情報",
			pageTitle: "顧客企業情報登録",
			customer_company: {
				industry_id: null,
				customer_company_share_info_id: null,
				name: null,
				full_name: null,
				customer_code: null,
				cutoff_date: null,
				city: null,
				prefecture: null,
				zipcode: null,
				address: null,
				building: null,
				phone: null,
				fax: null,
				email: null,
				customer_people_attributes: [],
				memos_attributes: [],
				customer_company_tag_ids: [],
			},
			customer_company_share_info: {
				name: null,
				capital: null,
				establishment_date: null,
				employees_number: null,
				representative: null,
				representative_kana: null,
				website: null,
			},
			industries: [],
			customer_company_share_infos: [],
			cutoffDates:[],
			uploadingFiles: [],
			valid: false,
			errors: [],
		}
	},
	mounted() {
		authenticate.authenticateUser()
		const headers = authenticate.setHeader()
		const url = `/erp/v1/customer_companies/new`
		axios
			.get(url, { headers })
			.then((res) => {
				this.cutoffDates = res.data.cutoff_dates
				this.industries = res.data.industries
				this.customer_company_share_infos = res.data.customer_company_share_infos
			})
			.catch((err) => {
				errorHandling.errorResponse(err)
			})
	},
	methods: {
		submitForm() {
			if (!this.$refs.form.validate()) return
			this.errors = []
			const customer_company = this.modifyParams()
			const headers = authenticate.setHeader()
			const url = `/erp/v1/customer_companies`
			axios
				.post(url, { customer_company, customer_company_share_info: this.customer_company_share_info }, { headers })
				.then((res) => {
					if (!this.uploadingFiles.length) return this.successUpload()
					this.uploadFiles(res.data.memos, 0, 0)
				})
				.catch((err) => {
					const error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
		modifyParams() {
			let customer_company = Object.assign({}, this.customer_company)
			this.uploadingFiles = customer_company.memos_attributes.filter((m) => !m._destroy).map((m) => m.files)
			customer_company.memos_attributes = customer_company.memos_attributes.filter(
				(m) => !m.user_id || m.user_id == this.$store.getters["auth/authData"].id
			)
			customer_company.memos_attributes = customer_company.memos_attributes.map((memo) => {
				delete memo.files
				delete memo.existing_files
				delete memo.uuid
				return memo
			})
			customer_company.customer_people_attributes = customer_company.customer_people_attributes.map((person) => {
				delete person.uuid
				return person
			})
			customer_company.customer_company_tag_ids = customer_company.customer_company_tag_ids.map((t) => t.id)
			return customer_company
		},

		uploadFiles(memos, memoNumber, i) {
			if (!this.uploadingFiles[memoNumber].length && memos.length == memoNumber + 1) {
				return this.successUpload()
			} else if (!this.uploadingFiles[memoNumber].length) {
				return this.uploadFiles(memos, memoNumber + 1, 0)
			}
			const id = memos[memoNumber].id
			let headers = authenticate.setHeader()
			headers["Content-type"] = "multipart/form-data"
			let formData = new FormData()
			formData.append("memo[file]", this.uploadingFiles[memoNumber][i])
			axios
				.post(`/erp/v1/memos/${id}/memo_files`, formData, { headers })
				.then((res) => {
					if (this.uploadingFiles[memoNumber].length == i + 1 && memos.length == memoNumber + 1) {
						this.successUpload()
					} else if (this.uploadingFiles[memoNumber].length == i + 1) {
						this.uploadFiles(memos, memoNumber + 1, 0)
					} else {
						this.uploadFiles(memos, memoNumber, i + 1)
					}
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		successUpload() {
			this.$router.push({ name: "customer_company_index" })
			this.$store.dispatch("setFlash", {
				type: "notice",
				text: "顧客データを作成しました。",
			})
		},
	},
}
</script>